import EcgLoaderSmall from './EcgLoaderSmall';

export default EcgLoaderSmall;
